/* eslint-disable */

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        const arr2 = Array(arr.length);
        for (var i = 0; i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    }
    return Array.from(arr);
}

const FRL = '__flex_root_listeners__';

export default {
    methods: {
        /**
         * Safely register event listeners on the root Vue node.
         * While Vue automatically removes listeners for individual components,
         * when a component registers a listener on root and is destroyed,
         * this orphans a callback because the node is gone,
         * but the root does not clear the callback.
         *
         * This adds a non-reactive prop to a vm on the fly
         * in order to avoid object observation and its performance costs
         * to something that needs no reactivity.
         * It should be highly unlikely there are any naming collisions.
         * @param {string} event
         * @param {function} callback
         * @chainable
         */
        listenOnRoot: function listenOnRoot(event, callback) {
            if (!this[FRL] || !Array.isArray(this[FRL])) {
                this[FRL] = [];
            }
            this[FRL].push({ event, callback });
            this.$root.$on(event, callback);
            return this;
        },

        /**
         * Convenience method for calling vm.$emit on vm.$root.
         * @param {string} event
         * @param {*} args
         * @chainable
         */
        emitOnRoot: function emitOnRoot(event) {
            let _$root;
            const _len = arguments.length;
            let args = Array(_len > 1 ? _len - 1 : 0);
            for (var _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            (_$root = this.$root).$emit.apply(
                _$root,
                [event].concat(_toConsumableArray(args))
            );
            return this;
        },
    },

    beforeDestroy: function beforeDestroy() {
        if (this[FRL] && Array.isArray(this[FRL])) {
            while (this[FRL].length > 0) {
                // shift to process in order
                const _FRL$shift = this[FRL].shift();
                const event = _FRL$shift.event;
                const callback = _FRL$shift.callback;

                this.$root.$off(event, callback);
            }
        }
    },
};
